<template>
  <li class="list-group-item">
    <div class="ana-item">
      <div class="d-flex align-items-center">
        <i class="fad fa-sort-up move-el"></i>
        <div class="d-flex">
          <div class="d-block pr-2">
            <b-avatar variant="info" :src="userProfile(item.profile)" />
          </div>
          <div>
            <span class="d-block font-weight-normal">{{ item.ad_soyad }}</span>
            <span class="d-block font-weight-light" style="font-size: 12px">{{ item.email }}</span>
          </div>
        </div>
      </div>
      <b-button-group>
        <b-button size="sm" variant="warning" tooltip="düzenle" class="rounded-0" @click="$emit('handlerUpdate', item)">
          <i class="fad fa-edit"></i>
        </b-button>
        <b-button size="sm" variant="danger" class="rounded-0" @click="handlerRemove(item.k_no)">
          <i class="fad fa-trash"></i>
        </b-button>
      </b-button-group>
    </div>
  </li>
</template>

<script>
import store from '@/store';
import Swal from 'sweetalert2';
import { defineComponent } from '@vue/composition-api';
import { useToast } from 'vue-toastification/composition';
export default defineComponent({
  props: {
    item: {
      type: Object,
      requied: true,
    },
  },
  setup(_, context) {
    const expo = {};
    const toast = useToast();

    expo.handlerRemove = (k_no) => {
      Swal.fire({
        title: 'Uyarı',
        text: 'Firmaya Ait Tüm Kayit Silinecektir',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Evet',
        cancelButtonText: 'Hayır',
      }).then((result) => {
        if (result.isConfirmed == true) {
          store.dispatch('kullaniciSil', k_no).then((res) => {
            if (res.data.success === true) {
              toast.error('Silme başarılı.', { position: 'bottom-left' });
              context.emit('show', false);
            }
          });
        }
      });
    };

    expo.userProfile = (val) => {
      if (val != undefined) {
        const fileName = store.getters.getUserFirma.db;
        let url = '';
        const base_url =
          process.env.NODE_ENV === 'development'
            ? process.env.VUE_APP_DEV_BASEURL.slice(0, -3)
            : process.env.VUE_APP_PRO_BASEURL.slice(0, -3);

        if (val == 'default.png') {
          url = `${base_url}uploads/no/${val}`;
        } else {
          url = `${base_url}uploads/${fileName}/profile/${val}`;
        }
        return url;
      }
    };

    return { ...expo };
  },
});
</script>

<style lang="scss" scoped></style>
